import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// O widget do Barnabe (public/index.html) e' injetado uma unica vez, no
// primeiro carregamento da aba -- e o site inteiro e' uma SPA (um so'
// BrowserRouter, ver src/index.js), entao navegar pro /admin e voltar NUNCA
// dispara um reload de verdade. Antes disso, quem decidia mostrar ou nao o
// widget era um script inline no index.html que olhava location.pathname
// uma unica vez: se a aba tivesse carregado em /admin (F5 direto la, ou um
// link externo), o widget nunca chegava a carregar, e nenhuma navegacao
// depois disso (nem "voltar" pro site) fazia ele aparecer -- o script que
// decide isso so' roda uma vez. (Caso real: Rodrigo entra no /admin e
// volta, o Barnabe some -- reportado.)
//
// Em vez de depender so' do load inicial, este componente fica de olho na
// rota atual o tempo todo (useLocation re-roda a cada navegacao, mesmo
// client-side) e so' ESCONDE/MOSTRA via CSS o host que o widget.js cria
// (#mosaico-agente, ver mosaico-api/src/agent/widget/widget.js, e a regra
// ".hide-agente-widget" no <style> do index.html) -- nunca depende de
// recarregar nada, entao funciona em qualquer sentido da navegacao.
const ADMIN_PATH_RE = /^\/(familia\/)?admin(\/|$)/;

export default function AgenteWidgetVisibility() {
  const location = useLocation();

  useEffect(() => {
    const isAdminRoute = ADMIN_PATH_RE.test(location.pathname);
    document.body.classList.toggle("hide-agente-widget", isAdminRoute);
  }, [location.pathname]);

  return null;
}
